import { useEffect, useState } from 'react';

import apiService from '@/lib/api/apiServices';

const useFetchEntities = (endpoint: string, queryParams: any, inputValue: string) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEntities = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const paramsWithPublicationState = {
          ...queryParams,
          publicationState: 'live',
        };
        const response = await apiService.get(`/${endpoint}`, paramsWithPublicationState, false);
        setData(response);
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (inputValue?.length > 2) {
      fetchEntities();
    } else {
      setData(null);
    }
  }, [endpoint, queryParams, inputValue]);

  return { data, isLoading, error };
};

export default useFetchEntities;
